// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".receipt-bundle-items[data-v-cb411f1c] .booking-items-list{border-radius:.5rem;border-width:8px 1px 1px;--tw-border-opacity:1;border-color:#e9e9f0;border-color:rgba(233,233,240,var(--tw-border-opacity));border-top-color:var(--color-brand-100);padding:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
